import React from "react";
import { Table } from "react-bootstrap";
import { connect } from "react-redux";

import ConditionsTableHeader from "./conditionsTableHeader";
import ConditionsItem from './conditionsItem';
import { formatCurrency } from "../utils/functions";

class ConditionsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      liste: [],
      labels: [],
      preisLabels: [],
      editMode: false,
    };
    // bind event listeners to this
    this.changeKondition = this.changeKondition.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  get liste() {
    if (this.props.defaultWerte) {
      return this.props.defaultWerte;
    }
    return Array.isArray(this.props.liste) ? this.props.liste : this.state.liste;
  }

  get labels() {
    return Array.isArray(this.props.labels) ? this.props.labels : this.state.labels;
  }

  get preisLabels() {
    return Array.isArray(this.props.preisLabels) ? this.props.preisLabels : this.state.preisLabels;
  }

  onChange(change) {
    // TODO update own local variables that are changed if no props are provided
    if (typeof this.props.onChange === "function") this.props.onChange(change);
    this.setState(change);
  }

  changeKondition(change) {
    if (!change) return;
    if (typeof change.editMode !== "undefined") {
      return this.onChange(change);
    }
  }

  renderListe() {
    return this.liste.map((item) => {
      const preis = item.preis && item.preis[0] ? Number(item.preis[0]) : 0;
      const preisLabel = this.preisLabels && this.preisLabels[0] ? this.preisLabels[0] : "";
      return (
        <tr key={`row${item.kennziffer}${item.bezeichnung}`} className="align-items-end">
          {!this.props.defaultWerte
            ? <td aria-label="Kennziffer" className="kennziffer">{item.kennziffer}</td>
            : null
          }
          <td aria-label="Bezeichnung" className="bezeichnung"><div className="nowrap">{item.bezeichnung}</div></td>
          {preisLabel && preis
            ? <td
              aria-label={preisLabel}
              className={"row-2 column-1 preis text-end"}
            >
              {formatCurrency(preis)}
            </td>
            : null
          }
          {item.konditionen
            ? item.konditionen.map((k, nr) => {
              return <td
                key={`kondition${k.row}_${k.col}`}
                aria-label={k.label || this.labels[nr] || ""}
                className={"row-3" + (k.changed ? " dirty" : "")}
              >
                <ConditionsItem
                  className="col"
                  item={item}
                  kondition={k}
                  onChange={this.changeKondition}
                  aktiveKonditionen={this.props.aktiveKonditionen}
                  editMode={this.state.editMode}
                  readOnly={this.props.readOnly}
                />
              </td>;
            })
            : null
          }
        </tr>
      );
    });
  }

  render() {
    return (
      <>
        {this.state.error
          ? <div className="alert alert-danger p-0 fs-6">{this.state.error}</div>
          : null
        }
        <Table id={this.props.id} striped bordered responsive>
          <ConditionsTableHeader
            variant={this.props.defaultWerte ? "default" : "data"}
            liste={this.liste}
            labels={this.props.labels}
            preisLabels={this.props.preisLabels}
            dirty={this.props.dirty}
            disabled={this.props.editMode || this.props.disabled}
            onChange={this.onChange}
          >
            {this.props.children}
          </ConditionsTableHeader>
          <tbody>
            {this.liste.length
              ? this.renderListe()
              : <tr><td colSpan={6}><div>Es wurden keine passenden Konditionen gefunden</div></td></tr>
            }
          </tbody>
        </Table>
      </>
    );
  }
}


export default connect(store => {
  return {
    configStorage: store.configStorage,
    konditionenStorage: store.konditionenStorage,
  };
})(ConditionsTable);
